import { createContext, useContext } from 'react';

/**
 * DOM node of the currently-rendering window's body container. In-body Radix
 * overlays (`popover`/`tooltip`, which portal to document.body at z-[50]) should
 * portal into THIS node instead so they layer relative to the window rather
 * than against the global z-band. Read it via `useFloatingWindowContainer()`
 * and pass it to Radix `<Portal container={...}>`.
 *
 * Kept in its own module (not FloatingWindowFrame.tsx) so the frame file only
 * exports a component — satisfies `react-refresh/only-export-components`.
 */
export const FloatingWindowContainerContext = createContext<HTMLElement | null>(
  null
);

export function useFloatingWindowContainer(): HTMLElement | null {
  return useContext(FloatingWindowContainerContext);
}
